// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1JqwC","footer":"ModalError_footer__2ltOE"};